/** Hindi. */
export const hi = {
    common: {
        save: 'सहेजें',
        saving: 'सहेजा जा रहा है…',
        saved: 'सहेजा गया',
        cancel: 'रद्द करें',
        delete: 'हटाएँ',
        edit: 'संपादित करें',
        close: 'बंद करें',
        back: 'वापस',
        retry: 'फिर कोशिश करें',
        loading: 'लोड हो रहा है…',
        search: 'खोजें',
        signOut: 'साइन आउट',
        store: 'स्टोर',
        status: 'स्थिति',
        email: 'ईमेल',
        password: 'पासवर्ड',
        firstName: 'पहला नाम',
        lastName: 'अंतिम नाम',
        phone: 'फ़ोन',
        total: 'कुल',
        subtotal: 'उप-योग',
        quantity: 'मात्रा',
        price: 'क़ीमत',
        stock: 'स्टॉक',
        language: 'भाषा',
        never: 'कभी नहीं',
        none: '—',
    },
    nav: {
        products: 'उत्पाद',
        orders: 'ऑर्डर',
        customers: 'ग्राहक',
        settings: 'सेटिंग्स',
        website: 'वेबसाइट',
        apps: 'ऐप्स',
        themes: 'थीम',
        installs: 'इंस्टॉलेशन',
    },
    auth: {
        signInTitle: 'साइन इन',
        signInSubtitle: 'अपने स्टोर एडमिन में साइन इन करें।',
        partnerSubtitle: 'व्यापारियों के लिए ऐप्स और थीम बनाएँ।',
        signIn: 'साइन इन करें',
        signingIn: 'साइन इन हो रहा है…',
        createStore: 'अपना स्टोर शुरू करें',
        creatingStore: 'आपका स्टोर बनाया जा रहा है…',
        haveAccount: 'पहले से स्टोर है? साइन इन करें',
        needAccount: 'अभी तक स्टोर नहीं? एक बनाएँ',
        storeName: 'स्टोर का नाम',
        storeAddress: 'स्टोर का पता',
        passwordHint: 'कम से कम 12 अक्षर',
        slugChecking: 'उपलब्धता जाँची जा रही है…',
        slugTaken: '{{slug}} पहले से लिया जा चुका है। हमारा सुझाव: {{suggestion}}।',
        slugFree: '{{slug}} उपलब्ध है।',
    },
    products: {
        title: 'उत्पाद',
        searchPlaceholder: 'शीर्षक, हैंडल या विक्रेता से खोजें…',
        newProduct: 'नया उत्पाद',
        columnProduct: 'उत्पाद',
        columnPrice: 'क़ीमत',
        columnStock: 'स्टॉक',
        columnVariants: 'वैरिएंट',
        statusActive: 'सक्रिय',
        statusDraft: 'ड्राफ़्ट',
        statusArchived: 'संग्रहीत',
        empty: 'अभी कोई उत्पाद नहीं। बेचना शुरू करने के लिए पहला उत्पाद जोड़ें।',
        variantCount: { one: '{{count}} वैरिएंट', other: '{{count}} वैरिएंट' },
        stockLevel: {
            zero: 'स्टॉक ख़त्म',
            one: '{{count}} स्टॉक में',
            other: '{{count}} स्टॉक में',
        },
        variantTitle: 'वैरिएंट का नाम',
        sku: 'SKU',
        couldNotLoadVariants: 'वैरिएंट लोड नहीं हो सके।',
    },
    orders: {
        title: 'ऑर्डर',
        searchPlaceholder: 'ऑर्डर नंबर या ईमेल से खोजें…',
        columnOrder: 'ऑर्डर',
        columnCustomer: 'ग्राहक',
        columnPayment: 'भुगतान',
        columnFulfilment: 'पूर्ति',
        columnPlaced: 'दिनांक',
        shipTo: 'भेजने का पता',
        item: 'वस्तु',
        qty: 'मात्रा',
        unit: 'प्रति इकाई',
        empty: 'अभी कोई ऑर्डर नहीं।',
        itemCount: { one: '{{count}} वस्तु', other: '{{count}} वस्तुएँ' },
        financial: {
            PENDING: 'भुगतान बाक़ी',
            AUTHORIZED: 'अधिकृत',
            PAID: 'भुगतान हो गया',
            PARTIALLY_REFUNDED: 'आंशिक रूप से वापस',
            REFUNDED: 'वापस कर दिया',
            VOIDED: 'रद्द',
        },
        fulfilment: {
            UNFULFILLED: 'पूर्ति बाक़ी',
            PARTIAL: 'आंशिक रूप से पूर्ण',
            FULFILLED: 'पूर्ण',
            RESTOCKED: 'स्टॉक में वापस',
        },
    },
    customers: {
        title: 'ग्राहक',
        searchPlaceholder: 'नाम या ईमेल से खोजें…',
        newCustomer: 'नया ग्राहक',
        columnCustomer: 'ग्राहक',
        columnOrders: 'ऑर्डर',
        columnMarketing: 'मार्केटिंग',
        lifetimeSpend: 'कुल ख़र्च',
        acceptsMarketing: 'मार्केटिंग स्वीकार',
        empty: 'अभी कोई ग्राहक नहीं।',
        orderCount: { zero: 'कोई ऑर्डर नहीं', one: '{{count}} ऑर्डर', other: '{{count}} ऑर्डर' },
    },
    settings: {
        title: 'स्टोर सेटिंग्स',
        storefront: 'आपका स्टोरफ़्रंट',
        storefrontHint: 'यह अभी लाइव है। लोकल डेवलपमेंट में सबडोमेन DNS में नहीं होता — स्टोरफ़्रंट डेव सर्वर उसकी जगह Host हेडर तय करता है।',
        details: 'विवरण',
        customDomain: 'अपना डोमेन',
        customDomainHint: 'एक CNAME को Upweo पर इंगित करें, फिर केवल होस्टनाम लिखें। ऊपर वाला पता इस्तेमाल करने के लिए ख़ाली छोड़ें।',
        addressHint: '{{host}} — इसे बदलने से मौजूदा लिंक टूट जाएँगे',
        currency: 'मुद्रा',
        country: 'देश',
        plan: 'योजना',
        currencyLocked: 'ऑर्डर बन जाने के बाद मुद्रा नहीं बदली जा सकती — पुराने कुल योग निरर्थक हो जाएँगे।',
        languages: 'भाषाएँ',
        defaultLanguage: 'डिफ़ॉल्ट भाषा',
        defaultLanguageHint: 'जब ग्राहक का ब्राउज़र ऐसी भाषा माँगे जो आप नहीं देते, तब उसे यही दिखेगा।',
        storefrontLanguages: 'स्टोरफ़्रंट की भाषाएँ',
        storefrontLanguagesHint: 'ग्राहक चुनी हुई भाषाओं के बीच बदल सकते हैं। अधूरे अनुवाद वाली दुकान दिखाने के बजाय किसी भाषा को हटाने के लिए उसका चयन रद्द करें।',
        saveFailed: 'सेटिंग्स सहेजी नहीं जा सकीं',
    },
    payments: {
        title: 'भुगतान',
        testMode: 'टेस्ट मोड',
        live: 'लाइव',
        needsWebhook: 'वेबहुक चाहिए',
        notConnected: 'कनेक्ट नहीं है',
        account: 'खाता',
        secretKey: 'सीक्रेट की',
        publishableKey: 'पब्लिशेबल की',
        webhookSecret: 'वेबहुक साइनिंग सीक्रेट',
        verified: 'सत्यापित',
        webhookEndpoint: 'वेबहुक एंडपॉइंट',
        connect: 'Stripe कनेक्ट करें',
        update: 'कीज़ अपडेट करें',
        disconnect: 'डिस्कनेक्ट करें',
        verifying: 'सत्यापित किया जा रहा है…',
        savedAndVerified: 'सहेजा और सत्यापित',
        copy: 'कॉपी करें',
        copied: 'कॉपी हो गया',
        disabledNotConnected: 'जब तक Stripe खाता कनेक्ट नहीं होता, चेकआउट बंद रहेगा। ग्राहक देख सकते हैं और कार्ट भर सकते हैं, पर भुगतान नहीं कर सकते।',
        disabledNoWebhook: 'आपकी कीज़ सहेज ली गई हैं, पर वेबहुक साइनिंग सीक्रेट जुड़ने तक चेकआउट बंद रहेगा। उसके बिना हम भुगतान शुरू तो कर सकते हैं पर कभी जान नहीं पाएँगे कि वह सफल हुआ — पैसा Stripe में आता रहेगा और ऑर्डर अवैतनिक पड़े रहेंगे।',
        secretKeyHintNew: 'sk_ या rk_ से शुरू होती है। एन्क्रिप्टेड सहेजी जाती है और दोबारा नहीं दिखाई जाती।',
        secretKeyHintExisting: 'पहले से सहेजी कुंजी रखने के लिए ख़ाली छोड़ें।',
        publishableKeyHint: 'pk_ से शुरू होती है। ग्राहक के ब्राउज़र को भेजी जाती है, इसलिए यह जान-बूझकर सार्वजनिक है।',
        webhookSecretHint: 'whsec_ से शुरू होती है। ऊपर एंडपॉइंट बनाते समय Stripe इसे एक ही बार दिखाता है।',
        saveFailed: 'भुगतान सेटिंग्स सहेजी नहीं जा सकीं',
        disconnectFailed: 'डिस्कनेक्ट नहीं हो सका',
    },
    shop: {
        shopAll: 'सब देखें',
        searchPlaceholder: 'खोजें…',
        soldOut: 'बिक गया',
        addToCart: 'कार्ट में डालें',
        adding: 'जोड़ा जा रहा है…',
        options: 'विकल्प',
        productNotFound: 'उत्पाद नहीं मिला',
        continueShopping: 'ख़रीदारी जारी रखें',
        poweredBy: '{{store}} — Upweo द्वारा संचालित',
        cart: 'कार्ट',
        cartEmpty: 'आपका कार्ट ख़ाली है',
        decreaseQuantity: 'मात्रा घटाएँ',
        increaseQuantity: 'मात्रा बढ़ाएँ',
        remove: 'हटाएँ',
        taxNotice: 'कर और शिपिंग अभी नहीं जोड़े गए हैं।',
        checkout: 'चेकआउट',
        contact: 'संपर्क',
        shippingAddress: 'शिपिंग पता',
        address: 'पता',
        city: 'शहर',
        postcode: 'पिन कोड',
        country: 'देश',
        orderSummary: 'ऑर्डर सारांश',
        editCart: 'कार्ट संपादित करें',
        continueToPayment: 'भुगतान पर जाएँ · {{total}}',
        preparingPayment: 'भुगतान तैयार किया जा रहा है…',
        payment: 'भुगतान',
        pay: '{{total}} का भुगतान करें',
        paying: 'भुगतान हो रहा है…',
        paymentSecurity: 'भुगतान Stripe द्वारा संसाधित होते हैं। आपके कार्ड का विवरण इस स्टोर तक कभी नहीं पहुँचता।',
        paymentFailed: 'भुगतान विफल रहा। दूसरा कार्ड आज़माएँ।',
        thankYou: 'धन्यवाद',
        orderPaid: 'ऑर्डर {{order}}, {{total}} का भुगतान हो चुका है।',
        confirmationSent: '{{email}} पर पुष्टि भेजी जा रही है।',
        cartCount: { zero: 'कार्ट', one: 'कार्ट ({{count}})', other: 'कार्ट ({{count}})' },
    },
    partner: {
        title: 'Upweo Partners',
        apps: 'ऐप्स',
        newApp: 'नई ऐप',
        clientId: 'क्लाइंट आईडी',
        clientSecret: 'क्लाइंट सीक्रेट',
        scopes: 'अनुमतियाँ',
        requestedScopes: 'माँगी गई अनुमतियाँ',
        installs: 'इंस्टॉलेशन',
        grantedScopes: 'दी गई अनुमतियाँ',
        installed: 'इंस्टॉल',
        themes: 'थीम',
        noThemes: 'अभी कोई थीम नहीं।',
        noApps: 'अभी कोई ऐप नहीं।',
        activePartnerAccount: 'सक्रिय पार्टनर खाता',
        installCount: {
            zero: 'इंस्टॉल नहीं',
            one: '{{count}} इंस्टॉल',
            other: '{{count}} इंस्टॉल',
        },
    },
    website: {
        subtitle: 'upweo.com पर सार्वजनिक साइट',
        copy: 'मार्केटिंग टेक्स्ट',
        copyHint: 'Upweo का दिया हुआ टेक्स्ट इस्तेमाल करने के लिए फ़ील्ड ख़ाली छोड़ें। धुँधला दिखने वाला टेक्स्ट इस भाषा का मौजूदा डिफ़ॉल्ट है।',
        clearHint: 'फ़ील्ड ख़ाली करने पर डिफ़ॉल्ट टेक्स्ट लौट आता है।',
        pricing: 'मूल्य योजनाएँ',
        pricingHint: 'क़ीमतें हर आगंतुक के अंक-प्रारूप में दिखती हैं। केवल टेक्स्ट का अनुवाद होता है — राशि हर जगह एक ही रहती है।',
        published: 'लाइव',
        hidden: 'छिपा हुआ',
        publish: 'प्रकाशित करें',
        hide: 'छिपाएँ',
        popular: 'सबसे लोकप्रिय',
    },
    site: {
        nav: {
            features: 'विशेषताएँ',
            pricing: 'क़ीमतें',
            partners: 'पार्टनर',
            signIn: 'साइन इन',
            startFree: 'मुफ़्त शुरू करें',
        },
        hero: {
            title: 'ऑनलाइन बेचने के लिए ज़रूरी सब कुछ',
            subtitle: 'Upweo आपको स्टोरफ़्रंट, चेकआउट और पीछे का कारोबार चलाने के उपकरण देता है — आपकी भाषा में, आपकी मुद्रा में, आपके अपने डोमेन पर।',
            ctaPrimary: 'अपना स्टोर बनाएँ',
            ctaSecondary: 'क़ीमतें देखें',
            note: 'शुरू करने के लिए कार्ड की ज़रूरत नहीं।',
        },
        features: {
            heading: 'असली दुकानों के लिए बना',
            subheading: 'ऑनलाइन कारोबार के वे हिस्से जिन्हें बनाना थकाऊ है — पहले से तैयार।',
            f1Title: 'आपका अपना स्टोरफ़्रंट',
            f1Body: 'साइन अप करते ही हर स्टोर को अपना पता मिल जाता है, और जब चाहें अपने डोमेन पर ले जा सकते हैं।',
            f2Title: 'उत्पाद और स्टॉक',
            f2Body: 'हर वैरिएंट की अपनी क़ीमत और SKU, हर स्थान पर स्टॉक, और ऑर्डर मिलते ही इन्वेंटरी सुरक्षित।',
            f3Title: 'असली भुगतान',
            f3Body: 'अपना Stripe खाता जोड़ें। ग्राहकों का पैसा सीधे आपके पास जाता है — हम कभी बीच में नहीं आते।',
            f4Title: 'आपके ग्राहकों की भाषा',
            f4Body: 'छह भाषाएँ, दाएँ-से-बाएँ लेखन का समर्थन, और हर देश के अनुसार क़ीमतों का प्रारूप। रसीद उसी भाषा में आती है जो ग्राहक पढ़ रहा था।',
            f5Title: 'ऑर्डर और ग्राहक',
            f5Body: 'हर ऑर्डर ख़रीद के समय का रिकॉर्ड रखता है, इसलिए कैटलॉग बदलने पर भी आपका इतिहास सही रहता है।',
            f6Title: 'ऐप्स और थीम',
            f6Body: 'OAuth, सीमित अनुमतियों और वेबहुक के साथ पार्टनर इकोसिस्टम — आपके डेटा को छुए बिना स्टोर का विस्तार।',
        },
        pricing: {
            heading: 'सरल क़ीमतें',
            subheading: 'मुफ़्त शुरू करें। ऑर्डर बढ़ें तो योजना बढ़ाएँ।',
            perMonth: '/माह',
            cta: 'शुरू करें',
            popular: 'सबसे लोकप्रिय',
            placeholderNotice: 'Upweo बीटा में है, इसलिए ये आँकड़े अस्थायी हैं। आज कोई शुल्क नहीं लिया जाता।',
            empty: 'क़ीमतें तय की जा रही हैं। तब तक स्टोर बनाना मुफ़्त है।',
        },
        partners: {
            heading: 'Upweo के लिए बनाएँ',
            subheading: 'व्यापारियों के लिए ऐप्स और थीम बनाएँ — सही OAuth प्रवाह, सीमित अनुमतियों और वेबहुक के साथ।',
            cta: 'पार्टनर बनें',
            signIn: 'पार्टनर साइन इन',
            b1Title: 'असली API',
            b1Body: 'सार्वजनिक GraphQL स्टोरफ़्रंट API और REST एडमिन API — दोनों संस्करणबद्ध।',
            b2Title: 'सीमित पहुँच',
            b2Body: 'व्यापारी वही अनुमतियाँ देते हैं जो आपकी ऐप माँगती है, और उन्हें वापस भी ले सकते हैं।',
            b3Title: 'वेबहुक',
            b3Body: 'जिन घटनाओं की परवाह है उन्हें सब्सक्राइब करें — हस्ताक्षरित और पुनःप्रयास सहित।',
        },
        signup: {
            heading: 'अपना स्टोर बनाएँ',
            subheading: 'लगभग एक मिनट लगता है। यह सब बाद में बदला जा सकता है।',
            submit: 'मेरा स्टोर बनाएँ',
            submitting: 'आपका स्टोर बनाया जा रहा है…',
            haveAccount: 'पहले से Upweo पर बेच रहे हैं? साइन इन करें',
            success: 'आपका स्टोर तैयार है। आपको डैशबोर्ड पर ले जा रहे हैं…',
        },
        partnerSignup: {
            heading: 'पार्टनर बनें',
            subheading: 'हमें अपने बारे में बताएँ। ऐप्स सार्वजनिक होने से पहले हम नए पार्टनर की समीक्षा करते हैं।',
            accountName: 'कंपनी या डेवलपर का नाम',
            submit: 'पार्टनर खाता बनाएँ',
            submitting: 'आपका खाता बनाया जा रहा है…',
            success: 'आपका पार्टनर खाता बन गया है और समीक्षा के लिए लंबित है। पोर्टल पर ले जा रहे हैं…',
            haveAccount: 'पहले से पार्टनर हैं? साइन इन करें',
            existingUserHint: 'पहले से Upweo खाता है? वही ईमेल और पासवर्ड इस्तेमाल करें, हम उसमें पार्टनर पहुँच जोड़ देंगे।',
        },
        footer: {
            tagline: 'मल्टी-टेनेंट कॉमर्स, खुले में बनाया गया।',
            product: 'उत्पाद',
            forPartners: 'पार्टनर के लिए',
            rights: '© {{year}} Upweo',
        },
    },
    errors: {
        BAD_REQUEST: 'यह अनुरोध समझा नहीं जा सका।',
        VALIDATION_FAILED: 'कृपया चिह्नित फ़ील्ड जाँचें।',
        UNAUTHENTICATED: 'कृपया दोबारा साइन इन करें।',
        FORBIDDEN: 'आपके पास यह करने की अनुमति नहीं है।',
        TENANT_NOT_RESOLVED: 'हम तय नहीं कर सके कि यह कौन-सा स्टोर है।',
        NOT_FOUND: 'यह नहीं मिला।',
        CONFLICT: 'यह पहले से मौजूद किसी चीज़ से टकराता है।',
        RATE_LIMITED: 'बहुत अधिक प्रयास। कृपया थोड़ा रुकें।',
        PAYMENT_FAILED: 'भुगतान पूरा नहीं हो सका।',
        INTERNAL_ERROR: 'हमारी ओर से कुछ ग़लत हो गया।',
        network: 'सर्वर तक नहीं पहुँच सके। अपना कनेक्शन जाँचें।',
    },
    email: {
        orderConfirmation: {
            subject: 'ऑर्डर {{order}} की पुष्टि',
            preheader: 'हमें आपका ऑर्डर और भुगतान मिल गया है।',
            heading: 'आपके ऑर्डर के लिए धन्यवाद',
            greeting: 'नमस्ते {{name}},',
            intro: '{{store}} को आपका ऑर्डर मिल गया है और आपका भुगतान स्वीकृत हो गया है।',
            orderLabel: 'ऑर्डर',
            datePlaced: 'दिनांक',
            itemsHeading: 'आपने क्या ऑर्डर किया',
            subtotal: 'उप-योग',
            shipping: 'शिपिंग',
            tax: 'कर',
            total: 'कुल',
            shippingTo: 'भेजने का पता',
            nextSteps: 'आपका ऑर्डर भेजे जाने पर हम आपको फिर ईमेल करेंगे।',
            footer: 'यह ईमेल {{store}} द्वारा भेजा गया है।',
        },
        passwordReset: {
            subject: 'अपना Upweo पासवर्ड रीसेट करें',
            preheader: 'नया पासवर्ड चुनने के लिए एक लिंक।',
            heading: 'अपना पासवर्ड रीसेट करें',
            intro: 'किसी ने {{email}} का पासवर्ड रीसेट करने का अनुरोध किया है।',
            action: 'नया पासवर्ड चुनें',
            expiry: 'यह लिंक एक बार काम करता है और {{minutes}} मिनट में समाप्त हो जाएगा।',
            ignore: 'अगर यह आपने नहीं किया, तो इस ईमेल को अनदेखा करें — आपका पासवर्ड नहीं बदला है।',
            footer: 'Upweo द्वारा भेजा गया।',
        },
    },
};
//# sourceMappingURL=hi.js.map